/**
 * Handles Favorites data
 *
 * @props
 * favorites: Object
 */
import { saveFavorite, removeFavorite } from "../lib";
import TrackMixin from "./TrackMixin";
var FavsMixin = {
  props: {
    favorites: {
      type: Object,
      default: () => ({
        diamonds: [],
      }),
    },
  },
  mixins: [TrackMixin],
  methods: {
    saveFavorites: function (event, diamond) {
      if (this.favorites.diamonds.find((d) => d.id === diamond.id)) {
        removeFavorite(diamond);
        // console.log("removing");
        this.favorites.diamonds = this.favorites.diamonds.filter(
          (d) => d.id !== diamond.id
        );
      } else {
        saveFavorite(diamond);
        this.favorites.diamonds.push(diamond);
      }
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    isFaved: function (diamond) {
      return this.favorites.diamonds
        .map((diamond) => diamond.id)
        .includes(diamond.id);
    },
  },
};
export default FavsMixin;
